/*
 * Created Date: Tuesday October 4th 2022
 * Author: Oskar Karnblad
 * License: Proprietary to Scaffcalc AB
 *
 * Copyright (c) 2022 Scaffcalc AB
 */
import { Stack } from "@mui/material";
import { FC } from "react";
import Chip, { ChipInterface } from "./Chip";

export interface ChipListInterface {
  chips: Array<ChipInterface>;
  direction: "row" | "column";
}

const ChipList: FC<ChipListInterface> = (props) => {
  const { chips, direction } = props;

  return (
    <Stack direction={direction} spacing={1} justifyContent={"center"}>
      {chips.map((chip, idx) => {
        return <Chip {...chip} key={idx} />;
      })}
    </Stack>
  );
};

export default ChipList;
